import { GropingFnParams } from '@epicuro-next/data/baskets-grouping';
import { captureException } from '@sentry/angular';
import { Basket } from 'graphql-api/baskets-api-interfaces';
import { fromWorker } from 'observable-webworker';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function getGroupedBasketWorker(input$: Observable<GropingFnParams>) {
  return fromWorker<GropingFnParams, Basket | null>(
    () =>
      new Worker(
        new URL(
          '@epicuro-next/workers/grouping-worker/grouping.worker',
          import.meta.url,
        ),
        {
          type: 'module',
        },
      ),
    input$,
    undefined,
    { terminateOnComplete: true },
  ).pipe(
    catchError((err) => {
      captureException(err);

      return of(null);
    }),
  );
}
